export const PROFILE_DRAFT = 'draft';
export const PROFILE_PENDING = 'pending';
export const PROFILE_APPROVED = 'approved';
export const PROFILE_DENIED = 'rejected';
export const PROFILE_INACTIVE = 'terminated';
export const PROFILE_DEACTIVE = 'deactive';
export const PROFILE_CANCELLED = 'cancelled';
export const PROFILE_DELETED = 'deleted';
export const PROFILE_INPROGRESS = 'inprogress';
export const PROFILE_UNSAVE = 'unsave';
export const PROFILE_COMPLETED = 'complete';
export const PROFILE_ACTIVE = 'active';
export const PROFILE_OFFBOARD = 'offboard';
export const PROFILE_STATUSES: { [index: string]: string } = {
  [PROFILE_DRAFT]: 'Draft',
  [PROFILE_PENDING]: 'Pending',
  [PROFILE_APPROVED]: 'Approved',
  [PROFILE_DENIED]: 'Rejected',
  [PROFILE_INACTIVE]: 'Terminated',
  [PROFILE_DEACTIVE]: 'Deactive',
  [PROFILE_CANCELLED]: 'Cancelled',
  [PROFILE_DELETED]: 'Deleted',
  [PROFILE_INPROGRESS]: 'In Progress',
  [PROFILE_COMPLETED]: 'Complete',
  [PROFILE_ACTIVE]: 'Active',
  [PROFILE_UNSAVE]: 'Unsave',
  [PROFILE_OFFBOARD]: 'Offboard',
};

export const PROFILE_STATUS_COLORS: { [index: string]: string } = {
  [PROFILE_DRAFT]: '#111827',
  [PROFILE_PENDING]: '#d97706',
  [PROFILE_APPROVED]: '#059669',
  [PROFILE_DENIED]: '#dc2626',
  [PROFILE_INACTIVE]: '#9ca3af',
  [PROFILE_DEACTIVE]: '#9ca3af',
  [PROFILE_CANCELLED]: '#9ca3af',
  [PROFILE_INPROGRESS]: '#059669',
  [PROFILE_COMPLETED]: '#d97706',
  [PROFILE_ACTIVE]: '#059669',
  [PROFILE_UNSAVE]: '#9ca3af',
  [PROFILE_OFFBOARD]: '#8b5cf6', // Màu tím cho trạng thái offboard
};

// Hàm helper để kiểm tra và trả về status phù hợp dựa trên endWorkingDate
export const getDisplayStatus = (status: string, endWorkingDate?: string | null): string => {
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);

  // Nếu có endWorkingDate và nó < ngày hiện tại thì kiểm tra offboard
  if (endWorkingDate) {
    const endDate = new Date(endWorkingDate);
    endDate.setHours(0, 0, 0, 0);

    // Nếu status là approved và có endWorkingDate < ngày hiện tại -> offboard
    if (status === 'approved' && endDate < currentDate) {
      return 'offboard';
    }
  }

  // Nếu status là approved thì luôn ánh xạ thành active (nhân viên đang hoạt động)
  if (status === 'approved') {
    return 'active';
  }

  return status;
};

// Hàm ánh xạ ngược từ display status về actual status (để gửi tới API)
export const getActualStatusForFilter = (displayStatus: string): string => {
  switch (displayStatus) {
    case 'Active':
      return 'approved'; // Active trong UI tương ứng với approved trong API (nhân viên đang hoạt động)
    case 'Offboard':
      return 'active'; // Offboard trong UI tương ứng với active trong API (nhân viên đã nghỉ việc)
    default:
      return displayStatus.toLowerCase();
  }
};
